import Market from './Market';

export interface IMove {
  x: number;
  y: number;
}

export interface IResize {
  width: number;
  height: number;
}

export interface IWRect {
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface IWWindowState {
  visible: boolean;
  state: 'maximized' | 'normal' | 'minimized';
  foreground: boolean;
  position: IWRect;
}

export interface IWBrowserWindowInfo {
  name: string;
  browserId: number;
  // can be zero
  openerId: number;
  // win32 window handle
  handle: number;
}

export interface ISetResizableOption {
  resizable: boolean;
}

export interface IGetOtherWindowInfoParam {
  name?: string;
  browserId?: number;
}

export interface ISystemScreenSize {
  width: number;
  height: number;
}

export interface IWBrowserWindowOptions {
  url: string;
  // must be global unique
  name?: string;
  width?: number;
  height?: number;
  x?: number;
  y?: number;
  minWidth?: number;
  minHeight?: number;
  maxWidth?: number;
  maxHeight?: number;
  resizable?: boolean;
  showInTaskbar?: boolean;
  showTitlebar?: boolean;
  disableZoom?: boolean;
  modalMode?: boolean;
  withExitCallback?: boolean;
  thirdPartyPage?: boolean;
  parentHandle?: number;
  titleBarButtons?: {
    refresh?: boolean;
    minimize?: boolean;
    maxRestore?: boolean;
    close?: boolean;
    fullScreen?: boolean;
    home?: boolean;
  };
  title?: string;
  titleBarStyle?: {
    hideTitlebarTitle?: boolean;
    color?: string;
    height?: number;
    textColor?: string;
  };
  offscreen?: boolean;
}

export interface IWClose {
  browserId?: number;
  force?: boolean;
}

export interface ISystemTaskBarPos {
  edge: 'left' | 'top' | 'right' | 'bottom';
  left: number;
  top: number;
  bottom: number;
  right: number;
}

export interface IWMax {
  browserId?: number;
  force?: boolean;
}

const Window = {
  /**
   * Show the browser window
   */
  Show: (): Promise<{}> => Market.__asyncCallApi('Window.Show', {}),
  Hide: (): Promise<{}> => Market.__asyncCallApi('Window.Hide', {}),
  Close: (params?: IWClose): Promise<{}> => Market.__asyncCallApi('Window.Close', params),
  MaximizeOrRestore: (params?: IWMax): Promise<{}> => Market.__asyncCallApi('Window.MaximizeOrRestore', params),
  Maximize: (params?: IWMax): Promise<{}> => Market.__asyncCallApi('Window.Maximize', params),
  Restore: (): Promise<{}> => Market.__asyncCallApi('Window.Restore', {}),
  Minimize: (): Promise<{}> => Market.__asyncCallApi('Window.Minimize', {}),
  Move: (params: IMove): Promise<{}> => Market.__asyncCallApi('Window.Move', params),
  FlashTaskbar: (): Promise<{}> => Market.__asyncCallApi('Window.FlashTaskbar', {}),
  Resize: (params: IResize): Promise<{}> => Market.__asyncCallApi('Window.Resize', params),
  MoveCenter: (): Promise<{}> => Market.__asyncCallApi('Window.MoveCenter', {}),
  StopFlashTaskbar: (): Promise<{}> => Market.__asyncCallApi('Window.StopFlashTaskbar', {}),
  SetCaptionArea: (areas: IWRect[]): Promise<{}> => Market.__asyncCallApi('Window.SetCaptionArea', { areas }),
  GetWindowState: (): Promise<IWWindowState> => Market.__asyncCallApi('Window.GetWindowState', {}),
  WindowStateChange: (): Promise<IWBrowserWindowInfo> => Market.__asyncCallApi('Window.WindowStateChange', {}),
  GetWindowInfo: (): Promise<IWBrowserWindowInfo> => Market.__asyncCallApi('Window.GetWindowInfo', {}),
  /**
   * if name is set, try find window with this name, otherwise find window the the browserId
   */
  GetOtherWindowInfo: (param: IGetOtherWindowInfoParam): Promise<IWBrowserWindowInfo> => Market.__asyncCallApi('Window.GetOtherWindowInfo', param),
  // OpenPopupBrowserWindow: (options: IWBrowserWindowOptions): Promise<IWBrowserWindowInfo> => {
  //   if (!options.disableZoom && options.width && options.height) {
  //     const zoom = parseInt(localStorage.getItem('zoom') || '1', 10);
  //     // 该方法会有36的标题栏
  //     options.width = Math.ceil(options.width * zoom);
  //     options.height = 36 + Math.ceil((options.height - 36) * zoom);
  //   }

  //   return Market.__asyncCallApi('Window.OpenPopupBrowserWindow', options);
  // },
  OpenPopupBrowserWindow: (options: IWBrowserWindowOptions): Promise<IWBrowserWindowInfo> => {
    if (!options.disableZoom && options.width && options.height) {
      const intZoom = parseInt(localStorage.getItem('zoom') || '1', 10);
      const zoom = intZoom === 0 ? 1 : intZoom;
      // 该方法会有36的标题栏
      options.width = Math.ceil(options.width * zoom);
      options.height = 36 + Math.ceil((options.height - 36) * zoom);
    }

    options.titleBarButtons = { ...{
      refresh: true,
      minimize: true,
      maxRestore: true,
      close: true,
      // 全屏按钮默认是关闭的
      fullScreen: false,
    },
    ...options.titleBarButtons };

    return Market.__asyncCallApi('Window.OpenPopupBrowserWindow', options);
  },
  SetResizable: (options: ISetResizableOption): Promise<{}> => Market.__asyncCallApi('Window.SetResizable', options),
  SetMinMaxInfo: (options: IWBrowserWindowOptions): Promise<{}> => Market.__asyncCallApi('Window.SetMinMaxInfo', options),
  /** 获取系统任务栏信息 */
  GetSystemTaskBarPos: (): Promise<ISystemTaskBarPos> => Market.__asyncCallApi('Window.GetSystemTaskBarPos', {}),
  /** 获取系统屏幕大小 */
  GetSystemScreenSize: (): Promise<ISystemScreenSize> => Market.__asyncCallApi('Window.GetSystemScreenSize', {}),
};

export default Window;
